
import { Options, Vue } from "vue-class-component";
import { RevenueDashboardController } from "@/app/ui/controllers/RevenueDashboardController";
import {
  TopCommodity,
} from "@/domain/entities/PosRevenue";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";

@Options({
  name: "TopCommoditySection",
  components: { }
})
export default class TopCommoditySection extends Vue {
  get isMobile() {
    return window.innerWidth <= 768;
  }

   get emptyStateData(): { headerMessage: string; message: string; icon: string } {
    return {
      headerMessage: this.$t("dashboard.topCommodity.emptyState.header"),
      message: this.$t("dashboard.topCommodity.emptyState.message"),
      icon: "noData_empty"
    };
  }
  
  formatDate(date: any) {
    return formatDate(date);
  }

  get lastSyncAt(): string | null {
    return RevenueDashboardController.topCommodityLastSyncAt;
  }

  get CityCode(): string {
    return RevenueDashboardController.topCommodityCityCode;
  }
  get isLoading(): boolean {
    return RevenueDashboardController.isLoadingTopCommodity;
  }

  get items(): TopCommodity[] {
    const list = RevenueDashboardController.topCommodityData || [];
    return list.slice(0, 20);
  }

  // Masking untuk kolom "Total booking di PLM"
  maskSttTotal(value: string | number): string {
    const str = String(value ?? "").trim();
    if (!str) return "-";

    const digitsOnly = str.replace(/[^\d]/g, "");
    if (digitsOnly) {
      const num = parseInt(digitsOnly, 10);
      if (!isNaN(num)) {
        if (num < 1000) {
          return "<1K";
        } else if (num < 5000) {
          return "1K+";
        } else {
          // Mulai dari 5K+, kelipatan 5K
          const label = Math.floor(num / 5000) * 5;
          return `${label}K+`;
        }
      }
    }

    if (/k\+\s*stt/i.test(str) || /stt$/i.test(str)) {
      return str;
    }
    return `${str} STT`;
  }

  get hasError(): boolean {
    return RevenueDashboardController.errorTopCommodity;
  }

  mounted(): void {
    const params: Record<string, any> = { limit: 20, page: 1 };
    if (this.isMyCommodityOnly) {
      // eslint-disable-next-line @typescript-eslint/camelcase
      params.booked_by_pos = "true";
    }
    RevenueDashboardController.fetchTopCommodityData(params);
  }

  get isMyCommodityOnly(): boolean {
    return RevenueDashboardController.filterMyCommodityOnly;
  }

  retryTopCommodity(): void {
    const params: Record<string, any> = { limit: 20, page: 1 };
    if (this.isMyCommodityOnly) {
      // eslint-disable-next-line @typescript-eslint/camelcase
      params.booked_by_pos = "true";
    }
    RevenueDashboardController.fetchTopCommodityData(params);
  }

  handleToggleMyCommodity(): void {
    const nextActive = !this.isMyCommodityOnly;
    const baseParams: Record<string, any> = { limit: 20, page: 1 };

    if (nextActive) {
      RevenueDashboardController.setFilterMyCommodityOnly(true);
      RevenueDashboardController.fetchTopCommodityData({
        ...baseParams,
        // eslint-disable-next-line @typescript-eslint/camelcase
        booked_by_pos: "true"
      });
    } else {
      RevenueDashboardController.setFilterMyCommodityOnly(false);
      RevenueDashboardController.fetchTopCommodityData(baseParams);
    }
  }

  get tooltipDescription(): string {
    return this.$t("dashboard.topCommodity.tooltip");
  }

  get tableColumns() {
    return [
      {
        name: this.$t("dashboard.topCommodity.table.trending"),
        styleHead: `text-center ${this.isMobile ? "w-200px" : ""}`,
        styleBody: "text-center",
        render: (item: any) =>
          `<div class="flex flex-row gap-1 items-center"><div class="bg-gray-lp-200 text-black-lp-100 text-xs">#${item.rank}</div> <div class=" text-sm text-black-lp-100 font-semibold break-all">${item.commodityName}</div></div>`
      },
      {
        name: this.$t("dashboard.topCommodity.table.bookingAtPos"),
        styleHead: `text-center`,
        styleBody: "text-center",
        render: (item: any) =>
          `<div class="text-black-lp-100 text-sm font-semibold text-center">${item.bookingAtPos} STT</div>`
      },
      {
        name: `${this.$t("dashboard.topCommodity.table.totalBooking")} ${this.CityCode}`,
        styleHead: `text-center`,
        styleBody: "text-center",
        render: (item: any) =>
          `<div class="text-green-lp-100 text-sm font-medium text-center">${this.maskSttTotal(item.bookingDestinationCity)}</div>`
      }
    ];
  }


}
